import { SYSEditorDialogBase } from "../../../src/library/dialog/editorbase"

export class SYSEditorAsset extends SYSEditorDialogBase {
  browseFileEl: HTMLInputElement
  async init() {
    this.formType = "SYSEditorAsset"

    await super.init()
  }
  async disconnectedCallback() {
    await super.disconnectedCallback()
  }
}
